const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || 'https://loansalary.in';

const resolveBase = (envValue, defaultPath) => {
  if (envValue) return envValue.replace(/\/$/, '');
  return defaultPath;
};

export const TASK_API_BASE = resolveBase(
  process.env.REACT_APP_TASK_API_BASE,
  '/Api/TaskApi'
);

export const loanBackendUrl = (endpoint) =>
  `${API_ORIGIN}/loan_backend/${String(endpoint).replace(/^\//, '')}`;

export const taskApiUrl = (endpoint) =>
  `${TASK_API_BASE}/${String(endpoint).replace(/^\//, '')}`;

export const taskApiDirectUrl = (endpoint) =>
  `${API_ORIGIN}/Api/TaskApi/${String(endpoint).replace(/^\//, '')}`;

export const saveLendingPageUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return taskApiUrl('saveLendingPage');
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host.includes('loansalary.in')) {
      return taskApiUrl('saveLendingPage');
    }
  }

  return taskApiDirectUrl('saveLendingPage');
};

export const formatApiMessage = (message) => {
  if (typeof message !== 'string') return 'Something went wrong. Please try again.';
  return message.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '').trim();
};

const isLocalDevHost = () => {
  if (typeof window === 'undefined') return process.env.NODE_ENV === 'development';
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
};

export const taskApiPostUrl = (endpoint) => {
  if (isLocalDevHost()) {
    return taskApiUrl(endpoint);
  }

  if (typeof window !== 'undefined' && window.location.hostname.includes('loansalary.in')) {
    return taskApiUrl(endpoint);
  }

  return taskApiDirectUrl(endpoint);
};
